import { request } from '../../Common/api/client';

/** GET /api/admin/cp-settlement/summary - 정산 합산 통계 */
export async function getAdminCpSettlementSummary(params = {}) {
  return request({ method: 'GET', url: '/api/admin/cp-settlement/summary', params });
}

/** GET /api/admin/cp-settlement - 정산 목록 */
export async function getAdminCpSettlementList(params = {}) {
  return request({ method: 'GET', url: '/api/admin/cp-settlement', params });
}

/** GET /api/admin/cp-settlement/detail - 정산 상세내역 */
export async function getAdminCpSettlementDetail(id, includeTransferLogs = 0) {
  return request({
    method: 'GET',
    url: '/api/admin/cp-settlement/detail',
    params: { id, includeTransferLogs },
  });
}

/** 계약별 지급 시도의 기존 결과를 조회한다. 새 지급 요청이 아니다. */
export async function checkUnmeContractPayoutResult(payoutId) {
  if (!/^\d+$/.test(String(payoutId ?? '')) || Number(payoutId) <= 0) throw new Error('지급 시도 ID를 확인할 수 없습니다.');
  return request({ method: 'POST', url: `/api/admin/cp-settlement/unme-contract-payouts/${encodeURIComponent(payoutId)}/result`, data: {} });
}
